import EditableScriptDetails from "../../../shared/editable-script-details/ScriptDetails";

function ScriptDetails(props) {
  function onSuccess() {
    console.log("Success management");
  }
  return <EditableScriptDetails onSuccess={onSuccess}></EditableScriptDetails>;
}

export default ScriptDetails;
